import { useQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';
import { queryKey } from '../../../../../constant/queryKey';

export const useGoodsPiecesFullLengthList = () => {
  const sno = useGoodsSno();
  const { data: goodsPieces } = useQuery({
    queryKey: queryKey.goodsPieces(sno),
    queryFn: () => goodsService.getGoodsPieces(sno),
  });

  const list =
    goodsPieces?.[0]
      ? goodsPieces[0].measurement.sizes.map(size => ({
          name: size.name,
          value:
            size.measure_values.find(item => item.spot.name === '총장')
              ?.value ?? undefined,
        }))
      : [];

  return { goodsPiecesFullLengthList: list };
};
